import { render, staticRenderFns } from "./Turbulence.vue?vue&type=template&id=099c2f8a"
import script from "./Turbulence.vue?vue&type=script&lang=js"
export * from "./Turbulence.vue?vue&type=script&lang=js"
import style0 from "./Turbulence.vue?vue&type=style&index=0&id=099c2f8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports